import { BBDTag, GraviButton, GraviGrid, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Cascader, TreeSelect } from 'antd'
import React, { useCallback, useMemo, useState } from 'react'

import { getColumnDefs } from './getColumnDefs'

const { SHOW_PARENT } = TreeSelect

export function AssignCardsModal({
  data,
  setSelectedDrivers,
  driversAssignGridAPIRef,
  loading,
  setSelectedOptions,
  setSelectedValues,
  selectedValues,
}) {
  const [searchValue, setSearchValue] = useState('')
  const columnDefs = useMemo(() => getColumnDefs(), [])
  const getRowId = useCallback((row) => row.data?.driver_id, [])
  const agPropOverrides = useMemo(
    () => ({
      getRowId,
      rowSelection: 'multiple',
      groupDisplayType: 'groupRows',
      groupDefaultExpanded: -1,
      groupSelectsChildren: true,
      groupSelectsFiltered: true,
      suppressRowClickSelection: true,
      groupRowRendererParams: { checkbox: true },
    }),
    []
  )
  const getTreeData = useMemo(() => {
    if (!data?.terminal_cards || !data?.terminal_cards?.length) return []
    return data.terminal_cards.map((terminal) => ({
      value: terminal.terminal_id,
      title: terminal.terminal_name,
      key: terminal.terminal_id,
      children: terminal.cards?.map((card) => ({
        value: `${card?.id}::terminal_id::${terminal.terminal_id}`,
        title: card?.name,
        key: `${card?.id}::terminal_id::${terminal.terminal_id}`,
      })),
    }))
  }, [data?.terminal_cards])

  const handleChange = (values, labels, extra) => {
    const payloadOptions = values
      ?.flatMap((option) => {
        if (option.includes(`::terminal_id::`)) {
          const ids = option.split(`::terminal_id::`)
          return {
            terminal_id: ids[1],
            card_id: ids[0],
          }
        }
        const terminal = data?.terminal_cards?.find((terminal) => {
          return terminal.terminal_id === option
        })

        if (terminal) {
          if (searchValue) {
            const res = terminal.cards?.map((card) => ({
              terminal_id: terminal.terminal_id,
              card_id: card.id,
            }))

            return res
          }
          return terminal.cards.map((card) => ({
            terminal_id: terminal.terminal_id,
            card_id: card.id,
          }))
        }
      })
    let newCards = values

    if (searchValue) {
      const { checked, triggerValue, preValue } = extra
      const isTerminal = !triggerValue.includes(`::terminal_id::`)
      if (checked) {
        if (isTerminal) {
          const terminal = data?.terminal_cards?.find((terminal) => {
            return terminal.terminal_id === triggerValue
          })
          const terminalNameFiltered = terminal.terminal_name.toLowerCase().includes(searchValue?.toLowerCase())
          const previousCards = preValue.map((c) => c.value)
          newCards = terminal.cards
            ?.filter((c) =>
              searchValue && !terminalNameFiltered ? c.name?.toLowerCase()?.includes(searchValue?.toLowerCase()) : true
            )
            .map((card) => `${card?.id}::terminal_id::${terminal.terminal_id}`)
            .concat(previousCards)
        } else {
          newCards = preValue.map((c) => c.value).concat(triggerValue)
        }
      } else {
        newCards = preValue.filter((card) => card !== triggerValue)
      }
    }
    setSelectedValues(newCards)
    setSelectedOptions(payloadOptions)
    setSearchValue('')
  }

  return (
    <Vertical style={{ minHeight: '80vh', maxHeight: '80vh' }}>
      <Vertical style={{ maxHeight: '90px', minHeight: '90px', overflowY: 'scroll' }} className='p-4' verticalCenter>
        <Texto>Select Terminal Cards:</Texto>
        <TreeSelect
          multiple
          allowClear
          showSearch
          style={{ width: '100%', maxWidth: '100%', minWidth: '200px' }}
          treeData={getTreeData}
          placeholder='Please select'
          showCheckedStrategy={SHOW_PARENT}
          treeDefaultExpandAll
          treeCheckable
          onChange={handleChange}
          value={selectedValues}
          maxTagCount='responsive'
          treeNodeFilterProp='title'
          onSearch={(value) => setSearchValue(value)}
        />
      </Vertical>
      <div style={{ height: '100%', overflowY: 'scroll' }}>
        <GraviGrid
          externalRef={driversAssignGridAPIRef}
          loading={loading}
          fullWidthSearchBar
          controlBarProps={{
            title: 'Drivers',
          }}
          rowData={data?.drivers || []}
          columnDefs={columnDefs}
          agPropOverrides={agPropOverrides}
          rowGroupPanelShow='always'
          sideBar={null}
          enableRangeSelection
          onSelectionChanged={(params) => {
            setSelectedDrivers(params.api.getSelectedRows())
          }}
        />
      </div>
    </Vertical>
  )
}
